export var EOperatorType;
(function (EOperatorType) {
    EOperatorType["LessThan"] = "LessThan";
    EOperatorType["LessThanOrEqual"] = "LessThanOrEqual";
    EOperatorType["GreaterThan"] = "GreaterThan";
    EOperatorType["GreaterThanOrEqual"] = "GreaterThanOrEqual"; // (>=)
})(EOperatorType || (EOperatorType = {}));
//# sourceMappingURL=operators.enum.js.map